import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class FacilitiesInformation extends VenueRegistrationFormModal {
	constructor() {
		super({
			wrapperSelector: '.p-venue-info-landing-page-singlesite',
			sectionWrapperSelector: '.p-venue-info-landing-page-singlesite-wrapper',
			modalSelector: '#js-venue-info-facilities-form-modal',
			triggerSelectors: ['.js-venue-info-add-facilities', '.js-venue-info-edit-facilities'],
			stepsEndpointAttr: 'facilities-steps-endpoint',
			submitEndpointAttr: 'facilities-submit-endpoint',
			logPrefix: 'FacilitiesInformation'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: true,
			isBackButtonEnabled: false,
			radioAnswerField: 'id',
			isRenderDependentQuestion: true,
			conditionalStepsVisiblity: true,
			exitButtonClasses: 'lta-form-generator__form-exit-button--underlined',
			nextStepButtonLabel: 'Save and continue',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue'
			}
		};
	}
}

VenueRegistrationFormModal.boot(FacilitiesInformation);

export default FacilitiesInformation;
